<div>
    <div v-show="!loading">
        <div class="text-danger" v-if="shippingAddresses === null || shippingAddresses.length <= 0">
            Customer Has No Shipping Addresses, therefore an order cannot be placed. Please add a Shipping Address for the customer.
        </div>
        <div class="table-responsive pt-4">
            <table class="table table-hover mb-0">
                <thead>
                <tr>
                    <th>
                        Select
                    </th>
                    <th>Site Name</th>
                    <th>Street Address</th>
                    <th>City</th>
                    <th>Postal Code</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(address, index) in shippingAddresses" :key="index">
                    <td>
                        <input type="checkbox" v-model="address.selected" @change="onShippingAddressSelect(address)">
                    </td>
                    <td>{{address.siteName}}</td>
                    <td>{{address.streetAddress}}</td>
                    <td>
                        {{address.city}}
                    </td>
                    <td>{{address.postalCode}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <loading-spinner :showSpinner="loading"></loading-spinner>
</div>